import React, { FC } from 'react';
import { Alert, Form, Modal } from 'antd';
import BuyerSupplierEmailNotificationFields from './BuyerSupplierEmailNotificationFields';

const SelfMangedSupplierEditModal: FC<any> = ({
	data,
	onCancel,
	handleSubmit,
	updating,
}): React.ReactElement => {
	const [form] = Form.useForm();

	return (
		<Modal
			width={600}
			title={`Update Notification Details`}
			okText="Update Supplier"
			onCancel={onCancel}
			onOk={form.submit}
			closable={false}
			visible={true}
			okButtonProps={{ loading: updating }}
		>
			<Form
				form={form}
				initialValues={data}
				onFinish={handleSubmit}
				layout="vertical"
				labelAlign="left"
				preserve={false}
			>
				<Form.Item>
					<Alert
						message="If you do not wish to send any notification to the supplier, please remove the entries below"
						type="info"
					/>
				</Form.Item>
				<BuyerSupplierEmailNotificationFields />
			</Form>
		</Modal>
	);
};

export default SelfMangedSupplierEditModal;
